// 西班牙语
const es = {
    // 首页-激活说明
    activateExplain: {
        title: 'Active su garantía extendida y obtenga el regalo especial para usted',
        desp: 'Condición aplicada: para calificar, los clientes aceptan compartir su experiencia de compra con nuestros productos comprados que han estado utilizando activamente durante al menos una semana.',
        conditions: [
            'Solo para clientes que compraron los productos en Amazon.',
            'Cada cliente solo puede reclamar un REGALO GRATIS para un producto. (Lo que significa que no importa cuántas veces compre el mismo producto, solo puede obtener un regalo GRATIS).',
        ]
    },
    // 首页-激活表单
    activateForm: {
        title: 'Active su garantía extendida y obtenga el regalo GRATIS AHORA！',
        desp: 'Solo disponible para clientes existentes',
        name: 'Nombre',
        namePlaceholder: `Ingrese el nombre del destinatario`,
        nameErrMsg: `Nombre incorrecto.`,
        email: 'Correo electrónico',
        emailPlaceholder: `Ingrese su correo electrónico`,
        emailErrMsg: `El correo electrónico es incorrecto.`,
        verifCode: 'Código de verificación',
        verifCodePlaceholder: `Ingrese su código de verificación`,
        verifCodeErrMsg: `código de verificación incorrecto.`,
        btnSendCode: `Envíe el código de verificación`,
        countdownMsg: `Reenviar en {countdown} segundos`,
        orderId: 'ID de pedido',
        orderIdPlaceholder: `Ingrese su ID de pedido`,
        orderIdErrMsg: `La identificación del pedido es incorrecta.`,
        orderAppliedError: `Este pedido ya ha solicitado un regalo.`,
        skuAppliedError: `El regalo de este pedido ha sido cobrado.`,
        orderIdHelp: '¿Cómo encontrar su ID de pedido?',
        btnAactivate: 'Activar ahora',
        statement: 'Ciertamente no compartiremos su información personal con otros.',
        orderIdErrPopoverMsg: 'Si la identificación de su pedido es correcta, comuníquese con nuestro servicio al cliente por correo electrónico. Le ayudaremos a activar la garantía extendida y confirmar si el evento cubre su mercado.',
        priceErrPopoverMsg: 'Lamentamos informarle que este pedido ha utilizado nuestro descuento mínimo, si tiene algún problema, bienvenido a enviarnos un correo electrónico.'
    },
    // 通用弹框
    commonModal: {
        msg: `{msg}`,
        msgContents: [
            `El nombre del destinatario no puede coincidir con el pedido`,
            `¿Se ha completado la revisión de Amazon?`,
            `¿Te gustaría continuar a Amazon para revisar?`
        ],
        btnRewrite: 'Volver a escribir',
        btnNo: 'NO',
        btnYes: 'SI'
    },
    // 选择礼物
    chooseGift: {
        title: 'Ahora, elige el regalo que quieras.',
        modalTitle: 'Lo sentimos, el regalo que has seleccionado ya no está disponible, elige de nuevo',
        btnWant: 'Lo quiero',
        btnStockout: 'Agotado'
    },
    // 订单信息
    orderInfo: {
        title: 'Enhorabuena! ¡Su garantía extendida está activada!',
        desp: 'Lo que obtendrás',
        orderTitle: 'La información de su pedido',
        orderId: 'Solicitar ID',
        productASIN: 'Producto ASIN',
        productName: 'Titulo del producto',
        address: 'Habla a',
        aboutGift: [
            'Sobre el regalo',
            'SIN gastos de envío, SIN tarifas ocultas, SIN tarjeta de crédito requerida',
            '4 pasos simples para obtenerlo (menos de 5 minutos).',
            'El regalo se le enviará dentro de 2-5 días hábiles después de que lo reclame.'
        ],
        btnWant: 'Lo quiero'
    },
    // 步骤1
    stepOne: {
        title: 'Paso 1 de 4: una breve encuesta sobre su compra.',
        questionList: [{
                id: 1,
                select_type: 'radio',
                name: 'sex',
                title: '1. Soy un ...?',
                option: [{
                        txt: 'Hembra',
                        value: 0
                    },
                    {
                        txt: 'Masculino',
                        value: 1
                    },
                    {
                        txt: 'No estoy seguro',
                        value: 2
                    }
                ]
            },
            {
                id: 2,
                select_type: 'radio',
                name: 'age',
                title: `2. ¿Cuál es tu rango de edad?`,
                option: [{
                        txt: 'Menos de 20',
                        value: 0
                    },
                    {
                        txt: '20-30',
                        value: 1
                    },
                    {
                        txt: '30-40',
                        value: 2
                    },
                    {
                        txt: '40-50',
                        value: 3
                    },
                    {
                        txt: '50-60',
                        value: 4
                    },
                    {
                        txt: 'Más de 60',
                        value: 5
                    }
                ]
            },
            {
                id: 3,
                select_type: 'radio',
                name: 'reason',
                title: '3. ¿Por qué nos elegiste?',
                option: [{
                        txt: 'Marca',
                        value: 0
                    },
                    {
                        txt: 'Diseño',
                        value: 1
                    },
                    {
                        txt: 'Precio',
                        value: 2
                    },
                    {
                        txt: 'Caracteristicas',
                        value: 3
                    },
                    {
                        txt: 'Comentarios',
                        value: 4
                    },
                    {
                        txt: 'Otras razones',
                        value: 5,
                        placeholder: 'Por favor ingrese una razón'
                    }
                ]
            },
        ],
        btnNext: 'próximo paso'
    },
    // 步骤2
    stepTwo: {
        title: 'Paso 2 de 4: cuéntanos tu experiencia sobre el producto.',
        despOne: `Calificación general?`,
        despTwo: `Háganos saber cómo funcionan nuestros productos para usted.`,
        notice: `(Ingrese al menos 10 caracteres)`,
        commentPlaceholder: 'Ingrese su comentario',
        commentErrMsg: `Las palabras de comentario no pueden exceder 20,000`,
        btnNext: 'próximo paso',
        btnPrev: 'paso anterior'
    },
    // 步骤3
    stepThree: {
        title: 'Pasos 3 de 4: comparta su experiencia de compra con otros.',
        desp: 'Solo te toma unos segundos. Sus comentarios ayudarían a otros clientes a tomar una mejor decisión de compra. Gracias por su comprensión y apoyo.',
        commentTitle: 'Tus comentarios',
        defaultComment: '¡Me gusta mucho tu producto!',
        btnCopyPost: 'Haga clic aquí para copiar y publicar su revisión amazom'
    },
    // 步骤4
    stepFour: {
        title: 'Paso 4 de 4: confirma tu dirección.',
        desp: 'Lo que obtendrás',
        fullName: 'Nombre completo',
        fullNamePlaceholder: `Ingrese su nombre completo`,
        fullNameErrMsg: `El nombre completo es incorrecto`,
        phone: 'Teléfono',
        phonePlaceholder: `Ingrese su teléfono`,
        phoneErrMsg: `El teléfono es incorrecto`,
        email: 'Correo electrónico',
        emailPlaceholder: `Ingrese su correo electrónico`,
        emailErrMsg: `El correo electrónico es incorrecto.`,
        address: 'Dirección',
        addressPlaceholder: `Ingrese su dirección`,
        addressErrMsg: `La dirección es incorrecta`,
        streetPlaceholder:`Dirección`,
        apartmentPlaceholder:`Unidad de apartamento`,
        cityPlaceholder:`Ciudad`,
        regionPlaceholder: `Seleccione región`,
        countryPlaceholder: `Elige un pais`,
        postcode: 'Código postal',
        postcodePlaceholder: `Ingrese su código postal`,
        postcodeErrMsg: `El código postal es incorrecto`,
        btnComfirm: 'Confirmar'
    },
    // 完成礼物申请
    completeApplication: {
        title: `Has terminado la aplicación de regalo gratis`,
        msgs: [
            'El regalo gratuito se enviará en 2-5 días hábiles.',
            'El regalo gratuito se enviará a su correo electrónico ',
            ' en 2-5 días hábiles.Sinceramente gracias por comprar nuestros productos, luego habrá un contacto dedicado del equipo de posventa.',
            'Si tiene más problemas, póngase en contacto con nuestro servicio al cliente por correo electrónico o visite nuestro sitio web oficial.',
            'Dado que no está 100% satisfecho con nuestros productos, puede comunicarse con nuestro servicio al cliente por correo electrónico o visitar nuestro sitio web oficial, habrá profesionales que lo atenderán. ¡100% de satisfacción del cliente es nuestra garantía!'
        ],
        btnComfirm: 'Confirmar'
    },
    // 获取订单号指导
    guide: {
        title: '¿Cómo encontrar su ID de pedido?',
        desps: [
            `Paso 1: Inicie sesión en su cuenta de Amazon y haga clic en "Su pedido" en la página Cuenta y listas`,
            `Paso 2: haga clic en "Detalles del pedido" en el pedido correcto`,
            `Paso 3: Verás tu ID de pedido`
        ],
        btnOK: 'Okay'
    }
}

export default es